import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    overrides: {
        MUIDataTableBodyRow: {
            root: {
                '&:nth-of-type(odd)': {
                background: '#FAFAFA'
                },
                background: '#fff'
            }
        },
        MUIDataTableHeadCell:{
            root:{
        zIndex:'unset!important' 
            }
        },
        MUIDataTableSelectCell:{
            root:{
                display: 'none',
                zIndex:'unset!important'
            }
        },
        MUIDataTableToolbar: {
            actions: {
                textAlign: 'left',
                width: '100%'
            },
            icon: {
                border: '1px solid #CCCCCC',
                bottom: '-5px',
                position: 'relative'       
            },
            iconActive: {
                border: '1px solid #CCCCCC',
                bottom: '10px',
            }
        },
		MUIDataTableToolbarSelect: {
			title: {
				display: 'none'
			}
		},
        MUIDataTableViewCol: {
            label: {
                display: 'inline-block'
            }
        },
        MuiCheckbox: {
            root: {
                color: '#1658A0'
            }
        },
       
        MuiIconButton: {
            root: {
                '&:first-of-type': {
                    borderBottomRightRadius: '0px',
                    borderTopRightRadius: '0px'
                },
                '&:last-of-type': {
                    borderBottomLeftRadius: '0px',
                    borderTopLeftRadius: '0px'
                },
                backgroundColor: '#cccccc',
                borderRight: '10px',
                color: '#1658A0'
                }
        },
        MuiMenu: {
            Paper: {
                overflow: 'hidden'
            }
        },
        MuiPaper: {
            elevation4: {
                boxShadow: 'none'
            }
        },
        MuiPopover: {
            paper: {
                left: '98px',
                top: '115px'
            }
        },
        MuiTable: {
            root: {
              borderCollapse: 'collapse',
            }
        },
        MuiTableCell: {
            body: {
                '&:first-of-type': {
                    border: '1px solid #cccccc',
                    borderBottomLeftRadius: '6px',
                    borderRight: 'none',
                    borderTopLeftRadius: '6px'
                },
                '&:last-of-type': {
                    border: '1px solid #cccccc',
                    borderBottomRightRadius: '6px',
                    borderLeft: 'none',
                    borderTopRightRadius: '6px', 
                },
                borderBottom: '1px solid #cccccc',
                height: '51px'
            },
            root: {
              borderBottom: 'none'  
            }
        },
        MuiTableHead: {
            root: {
                position: 'relative',
                zIndex: '1'
            }
        },
        MuiTableSortLabel: {
            icon: {
                position: 'relative',
                top: '5px'
            }
        }
    }
});

export default theme;
